import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Industries from './components/Industries';
import WhyChooseUs from './components/WhyChooseUs';
import WhatWeOffer from './components/WhatWeOffer';
import Projects from './components/Projects';
import DevelopmentProcess from './components/DevelopmentProcess';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import SoftwareProductDev from './pages/SoftwareProductDev';
import WebAppDev from './pages/WebAppDev';
import DevNetOps from './pages/DevNetOps';
import ITConsulting from './pages/ITConsulting';
import NewsPage from './pages/NewsPage';
import NewsDetail from './pages/NewsDetail';
import JobsPage from './pages/JobsPage';
import JobDetail from './pages/JobDetail';
import NetworkSecurity from './pages/NetworkSecurity';
import Cybersecurity from './pages/Cybersecurity';
import CloudInfrastructure from './pages/CloudInfrastructure';
import UIUXDesign from './pages/UIUXDesign';
import DataAnalytics from './pages/DataAnalytics';
import AboutUs from './pages/AboutUs';
import SEOHead from './components/SEOHead';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'DISION Tech LLC',
  url: 'https://dision.tech',
  description: 'DISION Tech provides innovative software development products and cybersecurity solutions.',
  address: { '@type': 'PostalAddress', addressLocality: 'Ho Chi Minh', addressCountry: 'VN' },
  contactPoint: { '@type': 'ContactPoint', email: 'info@dision.tech', contactType: 'customer service' },
  sameAs: ['https://www.linkedin.com/company/disiontech'],
};

function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Custom Software Development & Cybersecurity Solutions"
        description="DISION Tech LLC – Innovative custom software development, cybersecurity, DevNetOps and IT consulting for businesses of all sizes. Based in Ho Chi Minh, Vietnam."
        keywords="custom software development, cybersecurity solutions, DevNetOps, IT consulting, web application development, network security, Ho Chi Minh, Vietnam"
        url="/"
        schema={orgSchema}
      />
      <Navbar />
      <Hero />
      <Industries />
      <WhyChooseUs />
      <WhatWeOffer />
      <Projects />
      <DevelopmentProcess />
      <ContactCTA />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/development/software-product-development" element={<SoftwareProductDev />} />
          <Route path="/development/web-application-development" element={<WebAppDev />} />
          <Route path="/development/dev-net-ops-services" element={<DevNetOps />} />
          <Route path="/development/it-consulting-services" element={<ITConsulting />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/jobs/:slug" element={<JobDetail />} />
          <Route path="/services/network-security" element={<NetworkSecurity />} />
          <Route path="/services/cybersecurity" element={<Cybersecurity />} />
          <Route path="/services/cloud-infrastructure" element={<CloudInfrastructure />} />
          <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
          <Route path="/services/data-analytics" element={<DataAnalytics />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
